import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home.jsx";
import Header from "./Components/Header/Header.jsx";
import Residences from "./Components/Resdinces/Residences.jsx";
import Value from "./Components/Value/Value.jsx";
import Contact from "./Components/Contact/Contact.jsx";
import GetStart from "./Components/GetStart/GetStart.jsx";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/Homzy-Real-Estate" element={<Home />}></Route>
        <Route
          path="Homzy-Real-Estate/Residences"
          element={<Residences />}
        ></Route>
        <Route path="Homzy-Real-Estate/Value" element={<Value />}></Route>
        <Route path="Homzy-Real-Estate/Contact" element={<Contact />}></Route>
        <Route path="Homzy-Real-Estate/started" element={<GetStart />}></Route>
      </Routes>
    </div>
  );
}

export default App;
